import React from "react";
import { v4 as uuid } from "uuid";
import { BreadcrumbContainer } from "../../containers/BreadcrumbContainer";
import { Box } from "../Box";
import { FaqAccordionGroup, FaqAccordionGroupProps } from "../FaqAccordionGroup/FaqAccordionGroup";
import { PageContentWrapper } from "../PageContentWrapper";
import { QualtricsFeedback } from "../QualtricsFeedback";
import { SeoHeader, SeoHeaderProps } from "../SeoHeader";
import { ServiceCatalogueFooter } from "../ServiceCatalogueFooter";
import { ServiceCatalogueHeader } from "../ServiceCatalogueHeader";
import { Title } from "../Title";

interface Props {
  title: string;
  seo?: SeoHeaderProps;
  children?: React.ReactNode[] | React.ReactNode;
  faqs?: FaqAccordionGroupProps;
}

const PaddedBox = (props: React.PropsWithChildren<{}>) => <Box py={["16px", "36px", "36px", "36px"]} {...props} />;

export const ServiceCataloguePageWrapper: React.FC<Props> = ({ title, seo, children, faqs }) => (
  <>
    {seo && <SeoHeader {...seo} />}
    <ServiceCatalogueHeader />
    <PageContentWrapper maxWidth="1170px">
      <BreadcrumbContainer />
      <Title mb={["-8px", "-18px", "-18px", "-18px"]}>{title}</Title>
      {/* Key not relevant for static content - used to supress warnings. */}
      {children && Array.isArray(children) ? children.map(c => <PaddedBox key={uuid()}>{c}</PaddedBox>) : <PaddedBox>{children}</PaddedBox>}
      <PaddedBox>{faqs && <FaqAccordionGroup {...faqs} />}</PaddedBox>
      <PaddedBox>
        <QualtricsFeedback />
      </PaddedBox>
    </PageContentWrapper>
    <ServiceCatalogueFooter />
  </>
);
ServiceCataloguePageWrapper.defaultProps = {
};
